import { gql } from '@lojinha/palantir'

export const cookingTimeFragment = gql`
  fragment cookingTimeFragment on CookingTime {
    minutes
    seconds
  }
`

export const PRODUCT_QUERY = gql`
  query GetProduct($slug: String!, $distributionCenterId: String) {
    productBySlug(slug: $slug) {
      name
      id
      sku
      categories
      kind
      classification
      price
      priceFrom
      description
      imageUrl
      weight
      unit
      sellingStatus
      allergenics
      isAgeRestricted
      isAvailable(distributionCenterId: $distributionCenterId)
      seo {
        url
      }
      itemTags(maxTags: 4) {
        totalCount
        nodes {
          colorPalette
          content
        }
      }
      ingredients
      nutritionFacts {
        portionSize
        portionUnit
        facts {
          label
          value
          unit
          dailyValuePercentage
        }
      }
      cookingTimeMicrowave {
        ...cookingTimeFragment
      }
      cookingTimeOven {
        ...cookingTimeFragment
      }
      cookingTimeWaterBath {
        ...cookingTimeFragment
      }
    }
  }
  ${cookingTimeFragment}
`
